var ArticleSortable = {
  data() {
    return {
      articles: [],
      loading: false,
      saving: false,
    }
  },
  methods: {
    updateArticlesOrder() {
      this.saving = true
      var total = this.articles.length
      var data = {
        articles: this.articles.map((item, index) => { return { id: item.id, order: total - index } })
      }
      this.$article.updateArticleOrder(data, this.afterUpdate, this.handleUpdateOrderError)
    },
    afterUpdate() {
      this.saving = false
    },
    handleUpdateOrderError() {
      this.reload();
      alert('Something went wrong please try again');
    },
    reload() {
      this.loading = true;
      this.$article.fetchArticles({ type: this.articleType }, this.assignData)
    },
    assignData(response) {
      this.loading = false
      this.articles = response.data.articles
    },
    afterDestroy() {
      this.reload();
    },
    destroyArticle(article) {
      this.$modal.hide('edit-city-page-modal')
      this.$modal.hide('edit-post-modal')
      this.$modal.hide('confirm-modal')
      this.loading = true
      this.$article.destroyArticle(article.id, this.afterDestroy, this.handleUpdateOrderError)
    },
    openDestroyConfirm(article) {
      this.$modal.hide('edit-city-page-modal')
      this.$modal.hide('edit-post-modal')
      this.$modal.show('confirm-modal', {
        actionText: 'Delete',
        cancelText: 'Cancel',
        confirmMessage: `Are you sure to delete ${article.subject}`,
        confirmCallBack: () => this.destroyArticle(article),
      })
    },
  },
  mounted() {
    this.$user.fetchMe();
    this.reload();
  },
}

export default ArticleSortable;
